import logo from './logo.svg';
import './App.css';
import React, { useState, useEffect } from "react";
import Select from 'react-select';
import 'bootstrap/dist/css/bootstrap.min.css';
import './custom2.css';

import SweetAlert from 'react-bootstrap-sweetalert';
import conf from './metaconf.json'

import axios from 'axios'
import { Recommendations, RecommendationSummary } from './Recommendations';


import { MultiSelect } from "react-multi-select-component";
import { API_BASE_PATH } from './Api';


import styled from "styled-components";

const Input = styled.input.attrs(props => ({
  type: props.type=="password"?"password":"text",
  size: props.small ? 5 : undefined
}))`
  height: 32px;
  width: 200px;
  border-radius: 3px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border: 1px solid #e5e5e5;
  padding: 0 32px 0 16px;
`;

function isValidEmail(email) {
  return /^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[A-Za-z]+$/.test(email);
}


const optionsRecommendations = [
  { label: "Exceeded Predicted Quantity", value: "exQuantity" },
  { label: "Exceeded Predicted Amount", value: "exAmount" },
  { label: "No cross sell", value: "noCrossSell" },
  { label: "No up sell", value: "noUpSell" },
  { label: "No Focus product", value: "noFP" },
  { label: "No Mandated product", value: "noMandated" },
  { label: "No Must Order", value: "noMustOrder" },
  { label: "Other", value: "other" },


];

const optionsCrossSell = [
  { label: "Exceeded Predicted Quantity", value: "exQuantity" },
  { label: "No Crosssell Item", value: "noCrossSell" },
  { label: "Already Purchased By Outlet", value: "invalidItem" },
  { label: "Other", value: "other" }
];

const SectionUI = ({ currentConf, section, handleValueChange }) => {

  return (
    <div style={{ border: "1px dotted #aaa", padding: "10px", marginBottom: "10px", borderRadius: "10px" }}>

      <h5>{section.name}</h5>
      {section.attributes.map((attribute) => {
        console.log(attribute)
        return <>
          <div className="form-group">
            <label className="mb-0" style={{ width: "300px" }}>{attribute.displayName}<span className="text-danger"></span></label>

            {
              (attribute.type == "boolean") &&

              <select id={attribute.name} style={{ width: "200px", display: "inline-block" }} className="form-control" placeholder="Name" value={currentConf[attribute.name]||"None"} onChange={(e) => {
                handleValueChange(attribute.name, e.target.value)
              }}>
                <option>None</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            }

            {
              (attribute.type == "select" || attribute.options) &&

              <select id={attribute.name} style={{ width: "200px", display: "inline-block" }} className="form-control" placeholder="Name" value={currentConf[attribute.name]||"None"} onChange={(e) => {
                handleValueChange(attribute.name, e.target.value)
              }}>
                 <option>None</option>
                {
                  attribute.options.map((op) => {
                    if (typeof op == "object") {
                      return <option value={op.value}>{op.name}</option>
                    } else {
                      return <option value={op}>{op}</option>
                    }
                  })
                }

              </select>
            }

            {
              ((attribute.type == "string") || (attribute.type == "number")) && (!attribute.options) &&
              <Input
                id={attribute.name}
                type="text"
                placeholder=""
                onChange={e => handleValueChange(attribute.name, e.target.value)}
                value={currentConf[attribute.name]||""}
              />

            }

            {
              ((attribute.type == "password")) &&
              <Input
                id={attribute.name}
                type="password"
                placeholder=""
                onChange={e => handleValueChange(attribute.name, e.target.value)}
                value={currentConf[attribute.name]||""}
              />

            }

            {
              (attribute.type == "object") &&

              <textarea id={attribute.name} name="message" type="text" className="form-control" placeholder="Message" value={currentConf[attribute.name]?JSON.stringify(currentConf[attribute.name]):""} onChange={(e) => { handleValueChange(attribute.name, e.target.value) }} />


            }




            <label style={{ "width": "100%", fontSize: "10px", margin: "0px", color: "darkgrey" }}>{attribute.description}</label>

          </div>
        </>
      })
      }

    </div>
  );

}

const getTypedValue=(type,value)=>{
  switch ((type)) {
    case 'boolean':
      return (value=="None")?null:value;
    case 'number':
        return (value=="None"|| !value)?null:Number(value);
    default:
      return (value=="None"|| !value)?null: value;
  }
}

const Configuration = ({ selectedItem, statusInfo = {}, updater }) => {


  const getConfig = async () => new Promise((res, rej) => {
    axios.get(API_BASE_PATH + `/objects/config/key1/recommendations?lob=${userInfo.accountId}`)
      .then(response => {
        const data = response.data;
        res(data)
      })
      .catch(error => {
        console.log(error);
      })
  });
  const defConfig = (conf) => {
    var fo = {
    }
    conf.sections.map((section) => {
      section.attributes.forEach(a => {
        fo[a.name] = a.defaultValue;
      })
    });
    return fo;
  }
  
  useEffect(() => {
    getConfig().then(d => {
      if (d.length > 0) {
        d[0].payload.productConfiguration=d[0].payload.productConfiguration||{};
        d[0].payload.recPriorityIndex= d[0].payload.productConfiguration.recPriorityIndex;
        d[0].payload.productIndex= d[0].payload.productConfiguration.productIndex;
        if(d[0].payload.recPriorityIndex==-1){
          d[0].payload.useMaxPriceAsPriority=true;
        }
        setCurrentConf(d[0].payload);
      }else{
        setCurrentConf(defConfig(conf));
      }
    })
  }, []);

  const [loading, setLoading] = useState(false);

  const [showFailure, setFailure] = useState(false);
  const [showSuccess, setSuccess] = useState(false);
  const [currentConf, setCurrentConf] = useState({});
  var userInfo = localStorage.getItem("userInfo");
  if (userInfo) {
    userInfo = JSON.parse(userInfo);
  }





  const loginId = userInfo?.loginId;

  

  const updateRecommendations = async () => new Promise((res, rej) => {
    var fo = {
    }
    conf.sections.map((section) => {
      section.attributes.forEach(a => {
        if (a.parentObject) {
          var tv = getTypedValue(a.type,currentConf[a.name]);
          if(tv!=null){
            fo[a.parentObject] = fo[a.parentObject] || {};
            fo[a.parentObject][a.name] =tv;
          }// a.type == "boolean" ? Boolean(currentConf[a.name]) : currentConf[a.name];
        } else {
          var tv = getTypedValue(a.type,currentConf[a.name]);
          if(tv!=null){
            fo[a.name] = tv;
          }
        }
      })
    });

    setLoading(true)
    axios.post(API_BASE_PATH + `/objects/config/key1/recommendations?lob=${userInfo.accountId}&merge=false`, fo)
      .then(response => {
        const data = response.data;
        setSuccess(true);
        setLoading(false);
        res(data)
      })
      .catch(error => {
        console.log(error);
        setFailure(true);
        setLoading(false);
      })

     //alert(JSON.stringify(fo));

  });

  async function handleSave() {

    //category,score,message,
    // const id=selectedItem.selectedItem;
    await updateRecommendations()

  }

  const handleMessage = (e) => {
    const upd = Object.assign({}, statusInfo);
    upd.message = e.target.value;
    updater(upd)
  }

  const handleSelect = (e) => {

    const upd = Object.assign({}, statusInfo);
    upd.status = e.target.value;
    updater(upd)
  }

  const handleCategory = (e) => {
    const upd = Object.assign({}, statusInfo);
    upd.category = e;
    updater(upd)
  }

  const handleValueChange = (k, v) => {
    const cc = Object.assign({}, currentConf);
    cc[k] = v;
    console.log(cc[k])
    setCurrentConf(cc);
  }

  return (
    <>

      { showSuccess &&
        <SweetAlert success title="Success!" onConfirm={(e) => { setSuccess(false) }} onCancel={(e) => { setSuccess(false) }}>
          Successfully updated the configuration
</SweetAlert>
      }
      { showFailure &&
        <SweetAlert error title="Failure!" onConfirm={(e) => { setFailure(false) }} onCancel={(e) => { setFailure(false) }}>
          Error while updating configuration
</SweetAlert>
      }
      {
        <div style={{ height: "100%" }}>
          <div style={{ width: "600px" }} className="card shadow-sm border-0 px-3 rounded-2 mb-3 py-4 mx-auto mt-5 bg-light">
            <div className="card-header bg-transparent border-0 text-center text-uppercase"><h3></h3></div>
            <div className="card-body">
              <div>

                {loading && <h2>Loading.........</h2>}

                <div style={{padding:"10px",height:"60px",marginBottom:"10px",border:"1px dotted black"}}>
                <span style={{color:"green",fontSize:"14px"}}>Note: Make value as None for Selection fields and blank for text fields to ignore the configuration</span>
                </div>
                {!loading &&
                  
                  conf.sections.map((section) => {

                    return <SectionUI currentConf={currentConf} section={section} handleValueChange={handleValueChange} />

                  })
                }




                <div className="form-group">
                  <label className="mb-0">Message<span className="text-danger"></span></label>

                  <textarea name="message" type="text" className="form-control" placeholder="Message" value={statusInfo?.message || ""} onChange={handleMessage} />

                  <br></br>
                  <p className="text-center mb-0"><button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full" style={{
                    marginRight: "8px",
                    borderColor: "rgb(40, 96, 144)", boxShadow: "rgb(0 0 0 / 8%) 0px 1px 1px inset, rgb(165 202 234) 0px 0px 8px"
                  }} onClick={handleSave} value="Update" >Update</button></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      }

    </>
  );
};
export default Configuration;

